// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__WGFXx","footer":"ChangeClinic_footer__17fI0"};